<h2>{{ 'home.join-group-dialog.title' | translate | capitalize }}</h2>
<p class="bold form-title">{{ 'home.join-group-dialog.description' | translate | capitalize }}</p>
<mat-form-field appearance="outline" style="width: 100%">
  <mat-label>{{ 'general.words.groups' | translate | capitalize }}</mat-label>
  <mat-select cdkFocusInitial (selectionChange)="onGroupChange($event)">
    @for (group of filteredGroups; track group) {
      <mat-option [value]="group.id">
        {{ group.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
@if (selectedGroup && selectedGroup.pin) {
  <p class="bold form-title">{{ 'home.join-group-dialog.enter-pin' | translate | capitalize }}</p>
  <mat-form-field class="full-width" appearance="outline">
    <mat-label>{{ 'general.words.group-pin' | translate | capitalize }}</mat-label>
    <input [formControl]="pinFormControl" matInput />
  </mat-form-field>
}
<div class="dialog-actions">
  <button mat-stroked-button mat-dialog-close>{{ 'general.words.cancel' | translate | capitalize }}</button>
  <app-spinner-button
    [config]="btnConfig"
    (onClick)="save()"
    [disabled]="checkButtonDisabledState()"></app-spinner-button>
</div>
